import $ from 'jquery';
// Jarallax
import jarallax from '/node_modules/jarallax/dist/jarallax.min';

/* ===============================================================
  Jarallax Parallax - Simple & Fast
=============================================================== */
class JarallaxJs {
    constructor() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        const $elements = $('.irantheme-background-jarallax[data-image-url]');

        if ($elements.length) {
            $elements.each((index, element) => {
                const $el = $(element);
                const imageUrl = $el.attr('data-image-url');

                if (imageUrl) {
                    jarallax(element, {
                        imgSrc: imageUrl,
                        speed: 0.5,
                        type: 'scroll',
                        imgPosition: 'left',
                    });
                }
            });
        }
    }
}

export default JarallaxJs;
